import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbsiResource } from '../absi';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormStatusEnum } from 'src/app/common/enumerations/enumerations';
import { WFSectionLocalResource } from '../../workflow/workflow';
import { Observable, Subscription } from 'rxjs';
import { ActionItemsRefresh } from 'src/app/controls/catl/action-item/store/actionItems.action';

@Component({
  selector: 'absi-main-panel',
  templateUrl: './absi-main-panel.component.html',
  styleUrls: ['./absi-main-panel.component.scss']
})
export class AbsiMainPanelComponent extends BaseComponent implements OnChanges, OnInit {

  @Input() absi?: AbsiResource;

  formStatus = FormStatusEnum;
  panelOpenState = false;
  sectionInfo?: WFSectionLocalResource;

  sections?: WFSectionLocalResource[];
  sections$!: Observable<WFSectionLocalResource[]>;
  sectionsSubs!: Subscription;


  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.absi && this.absi.wfTable) {
      this.store.dispatch(new ActionItemsRefresh(this.absi.id));
      this.sections = this.absi.wfTable?.wfTableLocal?.wfSectionLocals.filter(s => s.number && s.number < 100).sort((a, b) => this.utils.sort(a.number, b.number));
      this.sectionInfo = this.absi.wfTable?.wfTableLocal?.wfSectionLocals.find(s => s.number && s.number == 100);
    }
    else {
      this.sectionInfo = { id: 0 };
    }
    this.cdRef.detectChanges();
    this.loadAbsiSections();
  }

  loadAbsiSections() {
    this.sections$ = this.store.select(state => state.AbsiSections.data);
    this.sectionsSubs = this.sections$.subscribe(data => {
      if (data?.length && data.some(x => x.wfTableID == this.absi?.wfTableID)) {
        this.sections = data.filter(s => s.wfTableID == this.absi?.wfTableID && s.number && s.number < 100).sort((a, b) => this.utils.sort(a.number, b.number));
        this.sectionInfo = data.find(s => s.wfTableID == this.absi?.wfTableID && s.number && s.number == 100);
      }
    });
  }

}
